function removeFileExt(fileName) {
  return fileName.slice(0, fileName.search(/\.[a-zA-Z0-9]+$/))
}

export default removeFileExt



// WEBPACK FOOTER //
// ./src/utils/removeFileExt.js